import React, { forwardRef } from "react";
import styled from "styled-components";

import { color, font, fontSize } from "./utils";
import { array, bool, string } from "prop-types";

const StyledLabel = styled.label`
  display: block;
  cursor: text;
  margin-top: 2rem;
  width: ${({ fullWidth }) => fullWidth && "100%"};
`;

const StyledSelectContainer = styled.div`
  align-items: center;
  border: 2px solid ${color("grey")};
  background: ${color("white")};
  border-radius: 5px;
  display: flex;
  font-size: 1rem;
  letter-spacing: 0.25px;
  margin-top: 0.5rem;
`;

const StyledSelect = styled.select`
  border: none;
  font-size: ${fontSize("sm")};
  font-family: ${font("ubuntu")};
  background: ${color("white")};
  outline: none;
  flex: 1;
  padding: 0.5rem;
`;

const SelectField = forwardRef(
  (
    {
      label,
      className,
      required,
      defaultValue,
      options,
      fullWidth = false,
      ...props
    },
    ref
  ) => {
    return (
      <StyledLabel className={className} fullWidth={fullWidth}>
        {label}
        {required && "*"}
        <StyledSelectContainer>
          <StyledSelect
            value={defaultValue}
            required={required}
            ref={ref}
            {...props}
          >
            {options.map(option => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
          </StyledSelect>
        </StyledSelectContainer>
      </StyledLabel>
    );
  }
);

SelectField.displayName = "SelectField";

SelectField.propTypes = {
  options: array.isRequired,
  label: string,
  className: string,
  required: bool,
  fullWidth: bool,
  selectedValue: string,
  defaultValue: string,
};

export default SelectField;
